class ScrollButton extends HTMLElement {
  constructor () {
    super()
    this.scrollButton = this.querySelectorAll('.js-button-scroll')
  }

  connectedCallback() {
    this.isScroll()
  }

  isScroll() {
    if (this.scrollButton.length > 0) {
      this.scrollButton.forEach((button) => {
        button.addEventListener('click', () => {
          try {
            const selector = button?.dataset?.anchorLink?.replace(/#/g, '')
            const targetElement = document.querySelector(`.${selector}`)
            const headerHeight = document.getElementById('section-header')?.offsetHeight || 0
  
            if (targetElement) {
              const targetPosition = getOffsetTop(targetElement) - headerHeight + 2
  
              window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
              })
            }
          } catch (error) {
            console.error(error)
          }
        })
      })
    }
  }
}

if (!customElements.get('button-scroll')) {
  customElements.define('button-scroll', ScrollButton)
}

const getOffsetTop = (element) => {
  let offsetTop = 0

  while (element) {
    offsetTop += element.offsetTop
    element = element.offsetParent
  }

  return offsetTop
}

window.addEventListener('DOMContentLoaded', () => {
  const hasUrlParams = window.location.hash.replace(/#/g, '')

  if (hasUrlParams) {
    setTimeout(() => { // setTimeout() to scroll to the right position after loadpage
      try {
        // getting errors when using dataset
        // Uncaught SyntaxError: Failed to execute 'querySelector' on 'Document': '.view=detail&id=381242' is not a valid selector.
        const targetElement = document.querySelector(`.${hasUrlParams}`)
        const headerHeight = document.getElementById('section-header')?.offsetHeight || 0

        if (targetElement) {
          const targetPosition = getOffsetTop(targetElement) - headerHeight - 4

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          })
        }
      } catch (error) {
        console.error(error)
      }
    }, 1000)
  }
})